<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
                                            <!-- Content Header (Page header) -->
        <section class="content-header">
            <h1>Shop Page<small><i class="ti-heart"></i><i class="ti-export"></i><i class="ti-printer"></i></small></h1>
            <ol class="breadcrumb">
                <li><router-link to="/"> <i class="ti-home"></i></router-link></li>
                <li><a href="#">Apps</a></li>
                <li class="active">Shop Page</li>
            </ol>
        </section>
            <!-- Main content -->
            <section class="content">
                      <div class="box" style="padding:30px;">

                          <div class="row">
                        <div class="col-md-12">
                            <!-- TABS -->
                            <ul class="nav nav-tabs nav-tabs-shop-devin" role="tablist">
                                <li class="" data-wow-delay="0.6s"><a href="#featured" data-toggle="tab" aria-expanded="false">featured</a></li>
                            <!--    <li class="active" data-wow-delay="0.4s"><a href="#best" data-toggle="tab" aria-expanded="true">bestsellers</a></li>
                                <li class="" data-wow-delay="0.2s"><a href="#new" data-toggle="tab" aria-expanded="false">new</a></li> -->
                            </ul>

                            <div class="tab-content">
                                <!-- TAB PANEL ITEM-->
                                <div  role="tabpanel" class="tab-pane fade active in" id="featured">
                                    <div class="row">
                                        <!-- PRODUCT SINGLE -->
                                        <div v-for="option in publishers" class="col-md-3 col-sm-6">
                                            <div class="product-item">
                                                <div class="product-item-thumbnail text-center mb-15">
                                                    <!-- <a class="product-item-thumbnail-link" href="#"></a> -->
                                                    <!-- <span class="product-item-thumbnail-label">new</span> -->
                                                    <img src="http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg" class="img-responsive" alt="product image">
                                                    <div class="product-item-thumbnail-overlay">
                                                        <router-link :to=" `${'/publisher/edit/' + option.uuid}`" class="btn btn-default pulse"><span class="ti-settings mr-0"></span></router-link>
                                                        <!-- <a href="/wwe" class="btn btn-primary">add to cart</a> -->
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-xs-6 publishers-all">
                                                    <h5  class = "publishers-name" style="">
                                                        <router-link :to=" `${'/publisher-info/' + option.id + '/'}`">{{option.name}}</router-link>
                                                    </h5>
                                                    </div>

                                                    <div class="col-xs-6 text-right">
                                                        <!-- <del class="h5 text-muted product-item-price-old">$99.00</del> -->
                                                        <!-- <span class="h5 product-item-price">Edit</span> -->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>  
                                    </div>
                                </div>
                                <!--/ TAB PANEL ITEM -->

                                <!-- TAB PANEL ITEM-->
                        <!--        <div role="tabpanel" class="tab-pane fade" id="best">
                                    <div class="row">                   
                                    </div>
                                </div> -->
                                <!--/ TAB PANEL ITEM -->

                                <!-- TAB PANEL ITEM-->
                        <!--        <div role="tabpanel" class="tab-pane fade" id="new">
                                    <div class="row">               
                                    </div>
                                </div> -->
                                <!--/ TAB PANEL ITEM -->
                            </div>
                            <!-- / TABS -->

                        </div>
                    </div>
                          <div class="row">
                    </div>
                          
    </div>
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
  import axios from 'axios'
  export default {
    data () {
      return {
        name: 'ShopHome',
        publishers: []
      }
    },
    beforeCreate: function () {
      this.$nextTick(function () {
        axios.get(baseUrl.url + 'v1/publishers/')
          .then(response => {
            this.publishers = response.data
          })
          .catch(error => {
            if (error.response.status == 400) {
              if (error.response.data) {
                console.log(error.response.data)
              }
            }
          })
      })
    },
    methods: {

    }

  }
</script>
<style>
  .publishers-all {
    width: 70%;
  }

  .publishers-name {
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: clip;
    height: 15px;
  }
</style>


// WEBPACK FOOTER //
// Profile.vue?6c7cd07d